import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-lock',
    templateUrl: './icon-lock.component.html'
})
export class IconLockComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
